<template>
  <div class="page-wrap">
    <div class="page-head" v-if="!profile">
      <div class="breadcrumbs">
        <div class="h1">
          <router-link class="link-not-like" to="/clients/">{{ $vuetify.lang.t('$vuetify.menu.clients') }}
          </router-link>
        </div>
        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.27539 13.7068L7.48229 7.49989L1.27539 1.29299" stroke="#2C1521" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="h1">
          {{ currentClient.name }}
        </div>
      </div>
    </div>

    <div class="profile profile--company">
      <div class="profile-main cards__single">
        <div class="profile-main__header">
          <div class="flex">
            <div class="profile-main__avatar cp">
              <img v-if="currentClient.logo_path" :src="$media_url + currentClient.logo_path" alt=""
                   @click="lightboxItems.push($media_url+currentClient.logo_path); index=0"/>
            </div>
            <v-file-input class="file-input--hide" v-model="photo" accept=".jpg, .png, .jpeg"
                          :placeholder="$vuetify.lang.t('$vuetify.downloadPhoto')" id="photo"></v-file-input>
            <div v-if="editing" class="link" @click="clickInput">
              <span v-if="photo">{{ photo.name }}</span>
              <span v-else>{{ $vuetify.lang.t('$vuetify.changePhoto') }}</span>
            </div>
          </div>

          <div class="profile-main__name h2" v-if="!editing">
            {{ currentClient.name }}
          </div>
          <div class="profile-main__name h2" v-if="editing">
            <v-text-field :label="$vuetify.lang.t('$vuetify.name2')" v-model="currentClient.name" outlined
                          :rules="[$rules.required]"></v-text-field>
          </div>
          <div class="profile-main__post"></div>
          <button v-if="permissions.edit.indexOf('Клиенты') || profile" class="editing-btn" @click="editing = !editing">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M15.8934 3.38037C16.5059 2.769 17.3317 2.41924 18.1969 2.40476C19.0622 2.39029 19.8993 2.71224 20.5318 3.30278C21.1644 3.89333 21.543 4.70635 21.5879 5.57054C21.6328 6.43474 21.3405 7.28263 20.7726 7.93557L20.6166 8.10357L9.08941 19.6308C8.8437 19.8761 8.5477 20.0653 8.22181 20.1852L8.02381 20.2488L3.15781 21.576C3.06355 21.6019 2.96438 21.6045 2.86891 21.5834C2.77345 21.5623 2.68458 21.5182 2.61006 21.4549C2.53553 21.3916 2.4776 21.311 2.44131 21.2203C2.40502 21.1295 2.39146 21.0312 2.40181 20.934L2.42101 20.838L3.74821 15.9732C3.83941 15.6372 4.00261 15.3252 4.22581 15.0612L4.36621 14.9076L15.8934 3.38037ZM14.8614 6.11037L5.21461 15.756C5.10439 15.8664 5.01676 15.9972 4.95661 16.1412L4.90621 16.2888L3.85381 20.1408L7.70821 19.0908C7.80861 19.0634 7.90502 19.023 7.99501 18.9708L8.12341 18.8844L8.24101 18.7824L17.8866 9.13437L14.8614 6.11037ZM19.7682 4.22877C19.3908 3.85113 18.8859 3.6282 18.3526 3.60378C17.8193 3.57936 17.2961 3.7552 16.8858 4.09677L16.7418 4.22877L15.7098 5.26077L18.7338 8.28717L19.7682 7.25517C20.1459 6.8778 20.3688 6.37289 20.3932 5.83957C20.4176 5.30626 20.2418 4.78308 19.9002 4.37277L19.7682 4.22877Z"
                  fill="#ADB2B7"/>
            </svg>
          </button>
          <v-checkbox v-if="permissions.admin" v-model="currentClient.read_timings"
                      @change="putClient"
                      :label="$vuetify.lang.t('$vuetify.read_timings')"></v-checkbox>
          <div class="" v-if="currentClient.auth_user && permissions.admin">
            {{ $vuetify.lang.t("$vuetify.lastLogin") }}:
            <span v-if="currentClient.auth_user.last_login">
            {{ new Date(currentClient.auth_user.last_login).toLocaleDateString('ru-Ru') }}
              {{ new Date(currentClient.auth_user.last_login).toLocaleTimeString('ru-Ru') }}
          </span>
          </div>
        </div>

        <div class="profile-main__options" v-if="!editing">
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.6 17.6005C5.41435 17.6005 5.2363 17.6743 5.10503 17.8056C4.97375 17.9368 4.9 18.1149 4.9 18.3005C4.9 18.4862 4.97375 18.6642 5.10503 18.7955C5.2363 18.9268 5.41435 19.0005 5.6 19.0005H8.4C8.58565 19.0005 8.7637 18.9268 8.89497 18.7955C9.02625 18.6642 9.1 18.4862 9.1 18.3005C9.1 18.1149 9.02625 17.9368 8.89497 17.8056C8.7637 17.6743 8.58565 17.6005 8.4 17.6005H5.6Z"
                    fill="#557EAE"/>
                <path
                    d="M2.8 0.800537C2.05739 0.800537 1.3452 1.09554 0.820101 1.62064C0.294999 2.14574 0 2.85793 0 3.60054V20.4005C0 21.1431 0.294999 21.8553 0.820101 22.3804C1.3452 22.9055 2.05739 23.2005 2.8 23.2005H11.2C11.9426 23.2005 12.6548 22.9055 13.1799 22.3804C13.705 21.8553 14 21.1431 14 20.4005V3.60054C14 2.85793 13.705 2.14574 13.1799 1.62064C12.6548 1.09554 11.9426 0.800537 11.2 0.800537H2.8ZM1.4 3.60054C1.4 3.22923 1.5475 2.87314 1.81005 2.61059C2.0726 2.34804 2.4287 2.20054 2.8 2.20054H11.2C11.5713 2.20054 11.9274 2.34804 12.1899 2.61059C12.4525 2.87314 12.6 3.22923 12.6 3.60054V20.4005C12.6 20.7718 12.4525 21.1279 12.1899 21.3905C11.9274 21.653 11.5713 21.8005 11.2 21.8005H2.8C2.4287 21.8005 2.0726 21.653 1.81005 21.3905C1.5475 21.1279 1.4 20.7718 1.4 20.4005V3.60054Z"
                    fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.phone') }}</div>

            <div class="profile-main__option-val">
              <a :href="'tel:' + currentClient.phone.replace(/\D/g, '')">{{ currentClient.phone }} </a>

            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.7008 0.599854C20.629 0.599854 21.5193 0.968602 22.1757 1.62498C22.832 2.28136 23.2008 3.1716 23.2008 4.09985V15.2999C23.2008 16.2281 22.832 17.1184 22.1757 17.7747C21.5193 18.4311 20.629 18.7999 19.7008 18.7999H4.30078C3.37252 18.7999 2.48228 18.4311 1.82591 17.7747C1.16953 17.1184 0.800781 16.2281 0.800781 15.2999V4.09985C0.800781 3.1716 1.16953 2.28136 1.82591 1.62498C2.48228 0.968602 3.37252 0.599854 4.30078 0.599854H19.7008ZM21.8008 6.14525L12.3564 11.7033C12.2671 11.7557 12.1673 11.7876 12.0642 11.7968C11.961 11.806 11.8571 11.7922 11.76 11.7565L11.6452 11.7033L2.20078 6.14805V15.2999C2.20078 15.8568 2.42203 16.391 2.81586 16.7848C3.20968 17.1786 3.74383 17.3999 4.30078 17.3999H19.7008C20.2577 17.3999 20.7919 17.1786 21.1857 16.7848C21.5795 16.391 21.8008 15.8568 21.8008 15.2999V6.14525ZM19.7008 1.99985H4.30078C3.74383 1.99985 3.20968 2.2211 2.81586 2.61493C2.42203 3.00876 2.20078 3.5429 2.20078 4.09985V4.52265L12.0008 10.2879L21.8008 4.51985V4.09985C21.8008 3.5429 21.5795 3.00876 21.1857 2.61493C20.7919 2.2211 20.2577 1.99985 19.7008 1.99985Z"
                    fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">email</div>

            <div class="profile-main__option-val">
              <a :href="'mailto:' + currentClient.email.toLowerCase().replace(' ', '')">{{ currentClient.email }}</a>
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.50059 7.80054C5.31493 7.80054 5.13689 7.87429 5.00561 8.00556C4.87434 8.13684 4.80059 8.31489 4.80059 8.50054C4.80059 8.68619 4.87434 8.86424 5.00561 8.99551C5.13689 9.12679 5.31493 9.20054 5.50059 9.20054H12.5006C12.6862 9.20054 12.8643 9.12679 12.9956 8.99551C13.1268 8.86424 13.2006 8.68619 13.2006 8.50054C13.2006 8.31489 13.1268 8.13684 12.9956 8.00556C12.8643 7.87429 12.6862 7.80054 12.5006 7.80054H5.50059ZM4.80059 12.7005C4.80059 12.5149 4.87434 12.3368 5.00561 12.2056C5.13689 12.0743 5.31493 12.0005 5.50059 12.0005H12.0386C11.8846 12.4387 11.8006 12.9105 11.8006 13.4005H5.50059C5.31493 13.4005 5.13689 13.3268 5.00561 13.1955C4.87434 13.0642 4.80059 12.8862 4.80059 12.7005ZM16.0006 4.30054V9.20054C16.4906 9.20054 16.9624 9.28454 17.4006 9.43994V4.30054C17.4006 3.74358 17.1793 3.20944 16.7855 2.81561C16.3917 2.42179 15.8575 2.20054 15.3006 2.20054H14.6006V1.50054C14.6006 1.31489 14.5268 1.13684 14.3956 1.00556C14.2643 0.874287 14.0862 0.800537 13.9006 0.800537C13.7149 0.800537 13.5369 0.874287 13.4056 1.00556C13.2743 1.13684 13.2006 1.31489 13.2006 1.50054V2.20054H9.70059V1.50054C9.70059 1.31489 9.62684 1.13684 9.49556 1.00556C9.36429 0.874287 9.18624 0.800537 9.00059 0.800537C8.81493 0.800537 8.63689 0.874287 8.50561 1.00556C8.37434 1.13684 8.30059 1.31489 8.30059 1.50054V2.20054H4.80059V1.50054C4.80059 1.31489 4.72684 1.13684 4.59556 1.00556C4.46429 0.874287 4.28624 0.800537 4.10059 0.800537C3.91493 0.800537 3.73689 0.874287 3.60561 1.00556C3.47434 1.13684 3.40059 1.31489 3.40059 1.50054V2.20054H2.70059C2.14363 2.20054 1.60949 2.42179 1.21566 2.81561C0.821835 3.20944 0.600586 3.74358 0.600586 4.30054V21.1005C0.600586 21.6575 0.821835 22.1916 1.21566 22.5855C1.60949 22.9793 2.14363 23.2005 2.70059 23.2005H10.0506C9.75247 22.7681 9.51462 22.2971 9.34359 21.8005H2.70059C2.51493 21.8005 2.33689 21.7268 2.20561 21.5955C2.07434 21.4642 2.00059 21.2862 2.00059 21.1005V4.30054C2.00059 4.11489 2.07434 3.93684 2.20561 3.80556C2.33689 3.67429 2.51493 3.60054 2.70059 3.60054H15.3006C15.4862 3.60054 15.6643 3.67429 15.7956 3.80556C15.9268 3.93684 16.0006 4.11489 16.0006 4.30054ZM5.50059 16.2005C5.31493 16.2005 5.13689 16.2743 5.00561 16.4056C4.87434 16.5368 4.80059 16.7149 4.80059 16.9005C4.80059 17.0862 4.87434 17.2642 5.00561 17.3955C5.13689 17.5268 5.31493 17.6005 5.50059 17.6005H8.30059C8.48624 17.6005 8.66429 17.5268 8.79556 17.3955C8.92684 17.2642 9.00059 17.0862 9.00059 16.9005C9.00059 16.7149 8.92684 16.5368 8.79556 16.4056C8.66429 16.2743 8.48624 16.2005 8.30059 16.2005H5.50059ZM18.8006 13.4005C18.8126 13.0256 18.7492 12.652 18.6141 12.3021C18.4789 11.9521 18.2749 11.6328 18.014 11.3633C17.753 11.0937 17.4406 10.8793 17.0952 10.7329C16.7499 10.5864 16.3786 10.5108 16.0034 10.5106C15.6283 10.5104 15.2569 10.5856 14.9114 10.7318C14.5659 10.8779 14.2532 11.092 13.9921 11.3613C13.7309 11.6306 13.5265 11.9496 13.391 12.2994C13.2555 12.6493 13.1917 13.0228 13.2034 13.3977C13.226 14.1247 13.5306 14.8143 14.0527 15.3206C14.5747 15.8269 15.2734 16.1103 16.0006 16.1106C16.7279 16.111 17.4268 15.8284 17.9494 15.3225C18.472 14.8167 18.7772 14.1274 18.8006 13.4005ZM10.4006 19.7005C10.4006 19.9413 10.4146 20.1751 10.4454 20.4005C10.5836 21.5669 11.1775 22.6313 12.0974 23.3615C13.1348 24.1945 14.5264 24.6005 16.0006 24.6005C17.4748 24.6005 18.8664 24.1945 19.9038 23.3615C20.9566 22.5145 21.6006 21.2629 21.6006 19.7005C21.6006 19.1436 21.3793 18.6094 20.9855 18.2156C20.5917 17.8218 20.0575 17.6005 19.5006 17.6005H12.5006C11.9436 17.6005 11.4095 17.8218 11.0157 18.2156C10.6218 18.6094 10.4006 19.1436 10.4006 19.7005Z"
                    fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">
              {{ $vuetify.lang.t('$vuetify.ogrn') }}

            </div>

            <div class="profile-main__option-val">
              {{ currentClient.ogrn }}
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.99922 0.800537C8.51401 0.800537 7.08962 1.39054 6.03942 2.44074C4.98922 3.49094 4.39922 4.91533 4.39922 6.40054C4.39922 7.88575 4.98922 9.31013 6.03942 10.3603C7.08962 11.4105 8.51401 12.0005 9.99922 12.0005C11.4844 12.0005 12.9088 11.4105 13.959 10.3603C15.0092 9.31013 15.5992 7.88575 15.5992 6.40054C15.5992 4.91533 15.0092 3.49094 13.959 2.44074C12.9088 1.39054 11.4844 0.800537 9.99922 0.800537ZM5.79922 6.40054C5.79922 5.28663 6.24172 4.21834 7.02937 3.43069C7.81702 2.64304 8.88531 2.20054 9.99922 2.20054C11.1131 2.20054 12.1814 2.64304 12.9691 3.43069C13.7567 4.21834 14.1992 5.28663 14.1992 6.40054C14.1992 7.51445 13.7567 8.58273 12.9691 9.37039C12.1814 10.158 11.1131 10.6005 9.99922 10.6005C8.88531 10.6005 7.81702 10.158 7.02937 9.37039C6.24172 8.58273 5.79922 7.51445 5.79922 6.40054Z"
                    fill="#557EAE"/>
                <path
                    d="M3.01182 13.4005C2.64311 13.3991 2.27774 13.4704 1.93665 13.6104C1.59557 13.7505 1.28548 13.9565 1.02418 14.2166C0.762878 14.4767 0.555497 14.7859 0.413932 15.1263C0.272366 15.4668 0.1994 15.8318 0.199219 16.2005C0.199219 18.5679 1.36542 20.3529 3.18822 21.5163C4.98302 22.6601 7.40222 23.2005 9.99922 23.2005C12.5962 23.2005 15.0154 22.6601 16.8102 21.5163C18.633 20.3543 19.7992 18.5665 19.7992 16.2005C19.7992 15.4579 19.5042 14.7457 18.9791 14.2206C18.454 13.6955 17.7418 13.4005 16.9992 13.4005H3.01182ZM1.59922 16.2005C1.59922 15.4263 2.22642 14.8005 3.01182 14.8005H16.9992C17.3705 14.8005 17.7266 14.948 17.9892 15.2106C18.2517 15.4731 18.3992 15.8292 18.3992 16.2005C18.3992 18.0331 17.5284 19.3981 16.057 20.3347C14.559 21.2909 12.4282 21.8005 9.99922 21.8005C7.57022 21.8005 5.43942 21.2909 3.94142 20.3347C2.47142 19.3967 1.59922 18.0345 1.59922 16.2005Z"
                    fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.address') }}</div>

            <div class="profile-main__option-val">
              <a target="_blank"
                 :href="'https://www.google.com/maps/search/?api=1&query='+currentClient.business_address.street + '+' + currentClient.business_address.house + '+' + currentClient.business_address.city">
                {{ currentClient.business_address.street }} {{ currentClient.business_address.house }}{{
                  currentClient.business_address.entrance ? currentClient.business_address.entrance : ''
                }} {{
                  currentClient.business_address.flat
                }}, {{ currentClient.business_address.index }} {{
                  currentClient.business_address.city
                }}, {{ currentClient.business_address.country }}
              </a>
            </div>
          </div>
        </div>
        <div class="profile-main__options no-gap" v-if="editing">
          <v-text-field :label="$vuetify.lang.t('$vuetify.phone')" v-model="currentClient.phone" outlined
                        :rules="[$rules.required]"></v-text-field>
          <v-text-field label="Email" v-model="currentClient.email" outlined :rules="[$rules.required, $rules.email]">
          </v-text-field>
          <v-text-field :label="$vuetify.lang.t('$vuetify.regNumber')" v-model="currentClient.ogrn" outlined
                        :rules="[$rules.required]">
          </v-text-field>
          <div class="h2">{{ $vuetify.lang.t('$vuetify.address') }}</div>
          <v-text-field v-model="currentClient.business_address.street" class="address__street"
                        :label="$vuetify.lang.t('$vuetify.street')" outlined :rules="[$rules.required]"></v-text-field>
          <div class="form__row form__address">
            <v-text-field v-model="currentClient.business_address.house" class="address__house"
                          :label="$vuetify.lang.t('$vuetify.house')" outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="currentClient.business_address.entrance" class="address__entrance"
                          :label="$vuetify.lang.t('$vuetify.entrance')" outlined></v-text-field>
            <v-text-field v-model="currentClient.business_address.flat" class="address__flat"
                          :label="$vuetify.lang.t('$vuetify.flat')" outlined>
            </v-text-field>
          </div>
          <v-text-field v-model="currentClient.business_address.index" class="address__index"
                        :label="$vuetify.lang.t('$vuetify.index')" outlined :rules="[$rules.required]"></v-text-field>
          <v-text-field v-model="currentClient.business_address.city" class="address__city"
                        :label="$vuetify.lang.t('$vuetify.city')" outlined :rules="[$rules.required]"></v-text-field>
          <v-text-field v-model="currentClient.business_address.country" class="address__country"
                        :label="$vuetify.lang.t('$vuetify.country')" outlined :rules="[$rules.required]"></v-text-field>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="editing = false; loadData()">
              {{ $vuetify.lang.t('$vuetify.back') }}
            </button>
            <button class="btn btn-primary" @click="edit_profile">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </div>
      </div>
      <div class="profile-tabs cards__single">
        <div class="profile-tabs__head">
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 4 }" @click="tab_selected = 4">
            {{ $vuetify.lang.t('$vuetify.menu.objects') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 5 }" @click="tab_selected = 5">
            {{ $vuetify.lang.t('$vuetify.staff') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 3 }" @click="tab_selected = 3">
            {{ $vuetify.lang.t('$vuetify.details') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 6 }" @click="tab_selected = 6">
            {{ $vuetify.lang.t('$vuetify.documents') }}
          </div>
        </div>
        <div class="profile-tabs__content">
          <div v-if="tab_selected === 4" class="profile-tabs__content-item">
            <div class="profile-objects">
              <div class="profile-objects-list">
                <div class="h2" @click="switch_object_list('start')">{{ $vuetify.lang.t('$vuetify.planning') }}</div>
                <div class="list" :class="{ 'm-hidden': objects_list_vis.start }">
                  <ProfileObjectCard v-for="object in objects.start" :key="object.id" :object_name="object.name"
                                     :object_id="object.id" :start_date="object.date_start" :end_date="object.date_end"
                                     :client_id="object.client_id.id" :client_logo="
                      object.client_id.logo_path ? object.client_id.logo_path : ''
                    " :client_name="object.client_id.name"></ProfileObjectCard>
                </div>
              </div>
              <div class="profile-objects-list">
                <div class="h2" @click="switch_object_list('now')">{{ $vuetify.lang.t('$vuetify.inProgress') }}</div>
                <div class="list" :class="{ 'm-hidden': objects_list_vis.now }">
                  <ProfileObjectCard v-for="object in objects.now" :key="object.id" :object_name="object.name"
                                     :object_id="object.id" :start_date="object.date_start" :end_date="object.date_end"
                                     :client_id="object.client_id.id" :client_logo="
                      object.client_id.logo_path ? object.client_id.logo_path : ''
                    " :client_name="object.client_id.name"></ProfileObjectCard>
                </div>
              </div>
              <div class="profile-objects-list">
                <div class="h2" @click="switch_object_list('end')">{{ $vuetify.lang.t('$vuetify.finished') }}</div>
                <div class="list" :class="{ 'm-hidden': objects_list_vis.end }">
                  <ProfileObjectCard v-for="object in objects.end" :key="object.id" :object_name="object.name"
                                     :object_id="object.id" :start_date="object.date_start" :end_date="object.date_end"
                                     :client_id="object.client_id.id" :client_logo="
                      object.client_id.logo_path ? object.client_id.logo_path : ''
                    " :client_name="object.client_id.name"></ProfileObjectCard>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tab_selected === 5" class="profile-tabs__content-item">

            <div class="staff">
              <div class="staff__item" v-for="contact in contacts" :key="contact.id">
                <div class="staff__avatar avatar">
                  <img :src="$media_url + contact.photo_path" alt=""/>
                </div>

                <div class="staff__name">
                  {{ contact.name }} {{ contact.lastname }}
                  <span class="staff__post">({{
                      contact.position.name[$vuetify.lang.current] ? contact.position.name[$vuetify.lang.current] : contact.position.name['eng'] ? contact.position.name['eng'] : contact.position.name['fin']
                    }})</span>
                </div>
                <div class="staff__contact">
                  <a :href="'mailto:' + contact.email.toLowerCase().replace(' ', '')">{{ contact.email }}</a>
                  <a :href="'tel:' + contact.phone.replace(/\D/g, '')">{{ contact.phone }}</a>
                </div>
                <div v-if="profile" class="staff__btns">
                  <button class="btn-icon btn-action" @click="contact_create_open(contact)">
                    <picture>
                      <edit-icon/>
                    </picture>
                  </button>
                  <button class="btn-icon btn-action" @click="confirm_contact_open(contact.id)">
                    <picture>
                      <delete-icon/>
                    </picture>
                  </button>
                </div>
              </div>
              <button v-if="profile || permissions.edit.indexOf('Контакты') !== -1" class="btn-secondary btn"
                      @click="contact_action = 'add'; contact_create_open();">
                + {{ $vuetify.lang.t('$vuetify.addContact') }}
              </button>
            </div>
          </div>
          <div v-if="tab_selected === 3" class="profile-tabs__content-item">

            <div class="details accordions">
              <div class="details__accordion profile-object" v-for="detail in details" :key="detail.id"
                   @click="opened_detail = (opened_detail === detail.id ? 0 : detail.id)">
                <div class="profile-object__title details__title">
                  {{ detail.name }}
                  <div class="rows__dot-menu">
                    <v-menu bottom right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn dark icon v-bind="attrs" v-on="on">
                          <svg
                              v-bind="attrs"
                              v-on="on"
                              width="20"
                              height="5"
                              viewBox="0 0 20 5"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                            <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                            <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
                          </svg>
                        </v-btn>
                      </template>
                      <div class="rows__dot-menu-content" v-if="profile || permissions.edit.indexOf('Клиенты') !== -1">
                        <div class="btn-wrap" @click="editDetailOpen(detail)">
                          {{ $vuetify.lang.t('$vuetify.edit') }}
                          <button class="btn-icon btn-action">
                            <edit-icon></edit-icon>
                          </button>
                        </div>
                        <div class="btn-wrap" @click="detail_delete=detail.id; confirm_detail_modal=true">
                          {{ $vuetify.lang.t('$vuetify.delete') }}
                          <button class="btn-icon btn-action">
                            <delete-icon></delete-icon>
                          </button>
                        </div>
                      </div>
                    </v-menu>
                  </div>
                </div>
                <div class="details__content accordion__content"
                     :class="{ 'accordion__content--close': opened_detail !== detail.id }">
                  <div class="detail__characteristic flex" v-for="(value, name) in detail.options"
                       :key="detail.id + name">
                    <span class="characteristics__title">{{ $vuetify.lang.t('$vuetify.' + name) }}</span>
                    <span class="characteristics__content">{{ value }}</span>
                  </div>
                  <div class="profile-object__company">
                    {{ detail.comment }}
                  </div>
                </div>
              </div>
              <button v-if="profile || permissions.edit.indexOf('Клиенты') !== -1" class="btn-secondary btn"
                      @click="addDetailModal = true; detail_action='add'">
                + {{ $vuetify.lang.t('$vuetify.addDetails') }}
              </button>
            </div>
          </div>
          <div v-if="tab_selected === 6" class="profile-tabs__content-item">
            <div class="documents">
              <div class="page__sorts">
                <router-link v-if="permissions.edit.indexOf('Бухгалтерия') !== -1"
                             class="btn-secondary btn link-not-like mb-2"
                             :to="'/bookkeeping/contracts/new?client=' + id">
                  + {{ $vuetify.lang.t('$vuetify.add') }}
                </router-link>
                <div class="documents__sorts">
                  <div class="sorts__radio">
                    <span>{{ $vuetify.lang.t('$vuetify.dataTable.sortBy') }}</span>
                    <div class="custom-radio">
                      <input v-model="sort" type="radio" name="sort" value="name" id="sort9"
                             class="custom-radio__hide"/>
                      <label for="sort9" class="custom-radio__button"><span></span></label>
                      <label for="sort9">{{ $vuetify.lang.t('$vuetify.sorts.byName') }}</label>
                    </div>
                    <div class="custom-radio">
                      <input v-model="sort" type="radio" name="sort" value="mode" id="sort10"
                             class="custom-radio__hide"/>
                      <label for="sort10" class="custom-radio__button"><span></span></label>
                      <label for="sort10">{{ $vuetify.lang.t('$vuetify.sorts.byType') }}</label>
                    </div>
                    <div class="custom-radio">
                      <input v-model="sort" type="radio" name="sort" value="create_date" id="sort7"
                             class="custom-radio__hide"/>
                      <label for="sort7" class="custom-radio__button"><span></span></label>
                      <label for="sort7">{{ $vuetify.lang.t('$vuetify.sorts.byCreateDate') }}</label>
                    </div>
                  </div>
                  <v-select class="sorts__select" v-model="sort" attach
                            :label="$vuetify.lang.t('$vuetify.dataTable.sortBy')"
                            :items="selectSorts" item-text="name" item-value="value"
                            :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu',
                                  }" outlined hide-details></v-select>
                </div>
              </div>
              <div class="page__sorts">
                <div class="page-head--right">
                  <div class="type-switcher">
                    <div class="type-switcher__item" :class="{ show: type == 'rows' }" @click="type = 'rows'">
                      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5"/>
                        <path
                            d="M9.20039 9.7998C8.723 9.7998 8.26516 9.98945 7.9276 10.327C7.59003 10.6646 7.40039 11.1224 7.40039 11.5998V13.9998C7.40039 14.4772 7.59003 14.935 7.9276 15.2726C8.26516 15.6102 8.723 15.7998 9.20039 15.7998H11.6004C12.0778 15.7998 12.5356 15.6102 12.8732 15.2726C13.2107 14.935 13.4004 14.4772 13.4004 13.9998V11.5998C13.4004 11.1224 13.2107 10.6646 12.8732 10.327C12.5356 9.98945 12.0778 9.7998 11.6004 9.7998H9.20039ZM8.60039 11.5998C8.60039 11.4407 8.6636 11.2881 8.77613 11.1755C8.88865 11.063 9.04126 10.9998 9.20039 10.9998H11.6004C11.7595 10.9998 11.9121 11.063 12.0247 11.1755C12.1372 11.2881 12.2004 11.4407 12.2004 11.5998V13.9998C12.2004 14.1589 12.1372 14.3115 12.0247 14.4241C11.9121 14.5366 11.7595 14.5998 11.6004 14.5998H9.20039C9.04126 14.5998 8.88865 14.5366 8.77613 14.4241C8.6636 14.3115 8.60039 14.1589 8.60039 13.9998V11.5998ZM16.4004 10.9998C16.2413 10.9998 16.0886 11.063 15.9761 11.1755C15.8636 11.2881 15.8004 11.4407 15.8004 11.5998C15.8004 11.7589 15.8636 11.9115 15.9761 12.0241C16.0886 12.1366 16.2413 12.1998 16.4004 12.1998H26.0004C26.1595 12.1998 26.3121 12.1366 26.4247 12.0241C26.5372 11.9115 26.6004 11.7589 26.6004 11.5998C26.6004 11.4407 26.5372 11.2881 26.4247 11.1755C26.3121 11.063 26.1595 10.9998 26.0004 10.9998H16.4004ZM16.4004 13.3998C16.2413 13.3998 16.0886 13.463 15.9761 13.5755C15.8636 13.6881 15.8004 13.8407 15.8004 13.9998C15.8004 14.1589 15.8636 14.3115 15.9761 14.4241C16.0886 14.5366 16.2413 14.5998 16.4004 14.5998H23.6004C23.7595 14.5998 23.9121 14.5366 24.0247 14.4241C24.1372 14.3115 24.2004 14.1589 24.2004 13.9998C24.2004 13.8407 24.1372 13.6881 24.0247 13.5755C23.9121 13.463 23.7595 13.3998 23.6004 13.3998H16.4004ZM9.20039 18.1998C8.723 18.1998 8.26516 18.3894 7.9276 18.727C7.59003 19.0646 7.40039 19.5224 7.40039 19.9998V22.3998C7.40039 22.8772 7.59003 23.335 7.9276 23.6726C8.26516 24.0102 8.723 24.1998 9.20039 24.1998H11.6004C12.0778 24.1998 12.5356 24.0102 12.8732 23.6726C13.2107 23.335 13.4004 22.8772 13.4004 22.3998V19.9998C13.4004 19.5224 13.2107 19.0646 12.8732 18.727C12.5356 18.3894 12.0778 18.1998 11.6004 18.1998H9.20039ZM8.60039 19.9998C8.60039 19.8407 8.6636 19.6881 8.77613 19.5755C8.88865 19.463 9.04126 19.3998 9.20039 19.3998H11.6004C11.7595 19.3998 11.9121 19.463 12.0247 19.5755C12.1372 19.6881 12.2004 19.8407 12.2004 19.9998V22.3998C12.2004 22.5589 12.1372 22.7115 12.0247 22.8241C11.9121 22.9366 11.7595 22.9998 11.6004 22.9998H9.20039C9.04126 22.9998 8.88865 22.9366 8.77613 22.8241C8.6636 22.7115 8.60039 22.5589 8.60039 22.3998V19.9998ZM16.4004 19.3998C16.2413 19.3998 16.0886 19.463 15.9761 19.5755C15.8636 19.6881 15.8004 19.8407 15.8004 19.9998C15.8004 20.1589 15.8636 20.3115 15.9761 20.4241C16.0886 20.5366 16.2413 20.5998 16.4004 20.5998H26.0004C26.1595 20.5998 26.3121 20.5366 26.4247 20.4241C26.5372 20.3115 26.6004 20.1589 26.6004 19.9998C26.6004 19.8407 26.5372 19.6881 26.4247 19.5755C26.3121 19.463 26.1595 19.3998 26.0004 19.3998H16.4004ZM16.4004 21.7998C16.2413 21.7998 16.0886 21.863 15.9761 21.9755C15.8636 22.0881 15.8004 22.2407 15.8004 22.3998C15.8004 22.5589 15.8636 22.7115 15.9761 22.8241C16.0886 22.9366 16.2413 22.9998 16.4004 22.9998H23.6004C23.7595 22.9998 23.9121 22.9366 24.0247 22.8241C24.1372 22.7115 24.2004 22.5589 24.2004 22.3998C24.2004 22.2407 24.1372 22.0881 24.0247 21.9755C23.9121 21.863 23.7595 21.7998 23.6004 21.7998H16.4004Z"
                            fill="#2A3F57"/>
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
                      </svg>
                    </div>
                    <div class="type-switcher__item" :class="{ show: type == 'cards' }" @click="type = 'cards'">
                      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M15.5738 8.86902C14.9918 8.3126 14.2024 8 13.3793 8H11.1034C10.2804 8 9.49099 8.3126 8.90898 8.86902C8.32697 9.42545 8 10.1801 8 10.967V13.5385C8 14.3254 8.32697 15.08 8.90898 15.6365C9.49099 16.1929 10.2804 16.5055 11.1034 16.5055H13.3793C14.2024 16.5055 14.9918 16.1929 15.5738 15.6365C16.1558 15.08 16.4828 14.3254 16.4828 13.5385V10.967C16.4828 10.1801 16.1558 9.42545 15.5738 8.86902ZM9.24138 13.5385V10.967C9.24138 10.4949 9.43756 10.0421 9.78677 9.70823C10.136 9.37437 10.6096 9.18681 11.1034 9.18681H13.3793C13.8732 9.18681 14.3468 9.37437 14.696 9.70823C15.0452 10.0421 15.2414 10.4949 15.2414 10.967V13.5385C15.2414 14.0106 15.0452 14.4634 14.696 14.7973C14.3468 15.1311 13.8732 15.3187 13.3793 15.3187H11.1034C10.6096 15.3187 10.136 15.1311 9.78677 14.7973C9.43756 14.4634 9.24138 14.0106 9.24138 13.5385Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M25.091 8.86902C24.509 8.3126 23.7196 8 22.8966 8H20.6207C19.7976 8 19.0082 8.3126 18.4262 8.86902C17.8442 9.42545 17.5172 10.1801 17.5172 10.967V13.5385C17.5172 14.3254 17.8442 15.08 18.4262 15.6365C19.0082 16.1929 19.7976 16.5055 20.6207 16.5055H22.8966C23.7196 16.5055 24.509 16.1929 25.091 15.6365C25.673 15.08 26 14.3254 26 13.5385V10.967C26 10.1801 25.673 9.42545 25.091 8.86902ZM18.7586 13.5385V10.967C18.7586 10.4949 18.9548 10.0421 19.304 9.70823C19.6532 9.37437 20.1268 9.18681 20.6207 9.18681H22.8966C23.3904 9.18681 23.864 9.37437 24.2132 9.70823C24.5624 10.0421 24.7586 10.4949 24.7586 10.967V13.5385C24.7586 14.0106 24.5624 14.4634 24.2132 14.7973C23.864 15.1311 23.3904 15.3187 22.8966 15.3187H20.6207C20.1268 15.3187 19.6532 15.1311 19.304 14.7973C18.9548 14.4634 18.7586 14.0106 18.7586 13.5385Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M15.5738 18.3635C14.9918 17.8071 14.2024 17.4945 13.3793 17.4945H11.1034C10.2804 17.4945 9.49099 17.8071 8.90898 18.3635C8.32697 18.92 8 19.6746 8 20.4615V23.033C8 23.8199 8.32697 24.5745 8.90898 25.131C9.49099 25.6874 10.2804 26 11.1034 26H13.3793C14.2024 26 14.9918 25.6874 15.5738 25.131C16.1558 24.5745 16.4828 23.8199 16.4828 23.033V20.4615C16.4828 19.6746 16.1558 18.92 15.5738 18.3635ZM9.24138 23.033V20.4615C9.24138 19.9894 9.43756 19.5366 9.78677 19.2027C10.136 18.8689 10.6096 18.6813 11.1034 18.6813H13.3793C13.8732 18.6813 14.3468 18.8689 14.696 19.2027C15.0452 19.5366 15.2414 19.9894 15.2414 20.4615V23.033C15.2414 23.5051 15.0452 23.9579 14.696 24.2918C14.3468 24.6256 13.8732 24.8132 13.3793 24.8132H11.1034C10.6096 24.8132 10.136 24.6256 9.78677 24.2918C9.43756 23.9579 9.24138 23.5051 9.24138 23.033Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M25.091 18.3635C24.509 17.8071 23.7196 17.4945 22.8966 17.4945H20.6207C19.7976 17.4945 19.0082 17.8071 18.4262 18.3635C17.8442 18.92 17.5172 19.6746 17.5172 20.4615V23.033C17.5172 23.8199 17.8442 24.5745 18.4262 25.131C19.0082 25.6874 19.7976 26 20.6207 26H22.8966C23.7196 26 24.509 25.6874 25.091 25.131C25.673 24.5745 26 23.8199 26 23.033V20.4615C26 19.6746 25.673 18.92 25.091 18.3635ZM18.7586 23.033V20.4615C18.7586 19.9894 18.9548 19.5366 19.304 19.2027C19.6532 18.8689 20.1268 18.6813 20.6207 18.6813H22.8966C23.3904 18.6813 23.864 18.8689 24.2132 19.2027C24.5624 19.5366 24.7586 19.9894 24.7586 20.4615V23.033C24.7586 23.5051 24.5624 23.9579 24.2132 24.2918C23.864 24.6256 23.3904 24.8132 22.8966 24.8132H20.6207C20.1268 24.8132 19.6532 24.6256 19.304 24.2918C18.9548 23.9579 18.7586 23.5051 18.7586 23.033Z"
                              fill="#2A3F57"/>
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <BaseTable :headers="headersDocuments" :type="type" :draggable_mode="false"
                         :show-headers="showHeadersDocuments" :sort="sort"
              >
                <template #cards="{ type,  headers, showHeaders }">
                  <BaseCard v-for="doc in documents" :key="doc.id" :type="type" :headers="headers"
                            :show-headers="showHeaders" :cp="true"
                            :title="doc.name" :photo="doc.path[0]" :card="doc" :options="doc.options"
                            :show-archive="false" :show-edit="false" :show-delete="false"
                            @open-photo="openPhoto(doc)"
                            @open="openPhoto(doc)"
                            @download-document="downloadDocument(doc)"
                  />
                </template>
              </BaseTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <contact-create-modal v-model="contact_create_modal" :contact_action="contact_action" :contact="newContact"
                          @save="loadContacts"></contact-create-modal>

    <v-dialog v-model="addDetailModal">
      <div class="modal">
        <div class="h1">
          <span v-if="detail_action === 'add'">{{ $vuetify.lang.t('$vuetify.addDetails') }}</span><span
            v-if="detail_action === 'edit'">{{ $vuetify.lang.t('$vuetify.editDetails') }}</span>
        </div>
        <v-form ref="form" @submit.prevent="" onkeydown="return event.key !== 'Enter';">
          <v-text-field :label="$vuetify.lang.t('$vuetify.name2')" v-model="newDetail.name"
                        outlined :rules="[$rules.required]"></v-text-field>
          <v-select v-model="newDetail.type" class="custom" :label="$vuetify.lang.t('$vuetify.selectType')"
                    :items="types" item-text="name" item-value="value" outlined attach
                    :menu-props="{
              bottom: true,
              offsetY: true,
              maxHeight: 200,
              contentClass: 'select-menu',
            }" :rules="[$rules.required]"></v-select>
          <div v-if="newDetail.type === 'bank'">
            <v-text-field v-model="newDetail.options.bank" :label="$vuetify.lang.t('$vuetify.accounting.card.bank')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.bic" label="S.W.I.F.T./BIC"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.iban" label="IBAN"
                          outlined :rules="[$rules.required]"></v-text-field>
          </div>
          <div v-if="newDetail.type === 'e-account'">
            <v-text-field v-model="newDetail.options.address"
                          :label="$vuetify.lang.t('$vuetify.accounting.card.address')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.operator"
                          :label="$vuetify.lang.t('$vuetify.operator')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.operator_id"
                          :label="$vuetify.lang.t('$vuetify.operator_id')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.invoice_address"
                          :label="$vuetify.lang.t('$vuetify.invoice_address')"
                          outlined :rules="[$rules.required]"></v-text-field>
          </div>
          <div v-if="newDetail.type === 'email'">
            <v-text-field v-model="newDetail.options.email" label="Email" outlined
                          :rules="[$rules.required, $rules.email]"></v-text-field>
          </div>
          <div v-if="newDetail.type === 'post'">
            <v-text-field v-model="newDetail.options.client_name"
                          :label="$vuetify.lang.t('$vuetify.client_name')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="newDetail.options.address"
                          :label="$vuetify.lang.t('$vuetify.accounting.card.address')"
                          outlined :rules="[$rules.required]"></v-text-field>
            <div class="form__row form__address">
              <v-text-field class="address__index"
                            v-model="newDetail.options.index"
                            :label="$vuetify.lang.t('$vuetify.index')"
                            outlined :rules="[$rules.required]"
              ></v-text-field>
              <v-text-field class="address__city"
                            v-model="newDetail.options.city"
                            :label="$vuetify.lang.t('$vuetify.city')"
                            outlined :rules="[$rules.required]"
              ></v-text-field>
            </div>
          </div>
          <v-textarea v-model="newDetail.comment" :label="$vuetify.lang.t('$vuetify.comment')" outlined></v-textarea>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="closeAddDetail">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="addDetail">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>

    <ConfirmModal v-model="confirm_detail_modal" @confirm="deleteDetail">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <ConfirmModal v-model="confirm_contact_modal" @confirm="deleteContact">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>


    <CoolLightBox
        :items="lightboxItems"
        :index="index"
        @close="index = null; lightboxItems=[]">
    </CoolLightBox>
  </div>
</template>
<script>
import ProfileObjectCard from "../parts/ProfileObjectCard.vue";
import ContactCreateModal from "@/components/ContactCreateModal";
import DeleteIcon from "@/components/icons/DeleteIcon";
import EditIcon from "@/components/icons/EditIcon";
import ConfirmModal from "@/components/confirmModal";
import {mapActions, mapGetters} from "vuex";
import BaseCard from "@/views/parts/BaseCard.vue";
import BaseTable from "@/views/parts/BaseTable.vue";

export default {
  name: "profile-view",

  components: {
    BaseTable, BaseCard,
    ConfirmModal,
    EditIcon,
    DeleteIcon,
    ContactCreateModal,
    ProfileObjectCard,
  },
  props: {
    id: [String, Number, undefined],
  },
  data: function () {
    return {
      profile: false,
      editing: false,
      objects_list_vis: {
        start: false,
        now: false,
        end: false
      },
      tab_selected: 4,
      tmp: 5,
      photo: null,
      currentClient: {
        business_address: {},
      },
      contacts: [],
      newContact: {},
      contact_action: "",
      contact_create_modal: false,
      confirm_contact_modal: false,
      contact_to_delete: null,

      details: [],
      opened_detail: 0,
      newDetail: {
        options: {},
        client: this.id,
      },
      types: [
        {name: this.$vuetify.lang.t('$vuetify.accounting.card.bank'), value: "bank"},
        {name: this.$vuetify.lang.t('$vuetify.e-account'), value: "e-account"},
        {name: this.$vuetify.lang.t('$vuetify.email'), value: "email"},
        {name: this.$vuetify.lang.t('$vuetify.accounting.card.address'), value: "post"},
      ],
      detail_action: "add",
      addDetailModal: false,
      confirm_detail_modal: false,
      detail_delete: 0,

      objects: {
        start: [],
        now: [],
        end: [],
      },
      documents: [],
      sort: '',
      selectSorts: [
        {name: this.$vuetify.lang.t('$vuetify.sorts.byName'), value: 'name'},
        {name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate'), value: 'create_date'},
        {name: this.$vuetify.lang.t('$vuetify.sorts.byType'), value: 'mode'},
      ],
      headersDocuments: [
        {key: "name", name: 'documentName'},
        {key: "mode.name", name: 'documentType'},
        {key: "create_date", name: 'dateDownload'},
      ],
      showHeadersDocuments: {
        'name': true,
        'mode.name': true,
        'create_date': true,
      },
      type: "rows",

      alertMsg: "",
      alertError: false,

      lightboxItems: [],
      index: null,
    };
  },

  watch: {
    sort() {
      this.loadDocuments()
    }
  },

  mounted: function () {
    this.checkPermission('Клиенты').then(() => {
      this.loadData();
    })
  },

  methods: {
    ...mapActions(['checkPermission']),

    switch_object_list(i) {
      this.objects_list_vis[i] = !this.objects_list_vis[i];
    },
    loadData: function () {
      if (this.id != undefined) {
        this.$axios({
          url: this.$hostname + "time-tracking/clients/" + this.id,
          type: "GET",
          headers: {
            Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                    sessionStorage.getItem("auth_token")),
          },
        }).then((response) => {
          this.currentClient = response.data.data.data[0];
          this.loadContacts()
          this.loadObjects();
          this.loadDocuments();
          this.loadDetails();
        }).catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
      } else {
        this.profile = true
        this.loadProfile()
      }
    },
    loadProfile() {
      this.$axios({
        url: this.$hostname + "time-tracking/user/full",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.currentClient = response.data.data.data
        this.loadContacts();
        this.loadObjects();
        this.loadDocuments();
        this.loadDetails();
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      });
    },
    loadContacts() {
      this.$axios({
        url:
            this.$hostname +
            "time-tracking/clients-employees?client=" + this.currentClient.id + "&position=Все",
        type: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.contacts = response.data.data.data;
      });
    },
    loadObjects() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/" + this.currentClient.id,
        method: "get",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.objects.start = response.data.data.data.filter(function (item) {
          return new Date(item.date_start) > new Date();
        });

        this.objects.now = response.data.data.data.filter(function (item) {
          return (
              new Date(item.date_start) <= new Date() &&
              (new Date(item.date_end) >= new Date() || item.date_end == undefined)
          );
        });

        this.objects.end = response.data.data.data.filter(function (item) {
          return (
              new Date(item.date_start) <= new Date() &&
              new Date(item.date_end) <= new Date() && item.date_end != undefined
          );
        });
      });
    },
    loadDetails() {
      this.$axios({
        url: this.$hostname + "time-tracking/clients/details/" + this.currentClient.id,
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.details = response.data.data.data
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadDocuments() {
      this.$axios({
        url: this.$hostname + "time-tracking/clients/documents/" + this.currentClient.id,
        type: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
        params: {
          sort: this.sort
        }
      })
          .then((response) => {
            this.documents = response.data.data.data
            this.documents.forEach(doc => {
              doc.path = JSON.parse(doc.path)
            })
            this.documents = this.documents.map(d => ({
              ...d,
              "mode.name": this.$vuetify.lang.t('$vuetify.accounting.' + d.mode.name + '.label'),
              options: [
                {
                  value: new Date(d.create_date).toLocaleDateString(),
                  icon: '<svg width="24" height="24" focusable="false"\n' +
                      '                   aria-hidden="true" viewBox="0 0 24 24" data-testid="AssignmentOutlinedIcon"><path\n' +
                      '                d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"></path></svg>\n'
                },
                {
                  value: this.$vuetify.lang.t('$vuetify.accounting.' + d.mode.name + '.label'),
                  icon: '<svg width="24" height="24" focusable="false"\n' +
                      '                   aria-hidden="true" viewBox="0 0 24 24" data-testid="AssignmentOutlinedIcon"><path\n' +
                      '                d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"></path></svg>\n'
                },
              ]
            }))
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },
    downloadDocument(item) {
      let path = ''
      if (item.zip) {
        path = item.zip
      } else {
        path = item.path[0]
      }
      let name = path.substr(path.lastIndexOf('/') + 1)
      this.$axios({
        url: this.$hostname + 'media/' + path,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', name);
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(e => {
        alert(e)
      })
    },
    openPhoto(item) {
      this.lightboxItems = []
      item.path.forEach(p => {
        if (['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(p.substr(p.lastIndexOf('.') + 1))) {
          this.lightboxItems.push(this.$hostname + 'time-tracking/preview/' + p)
        }
        if (new Date(p.create_date).toDateString() >= new Date('29/05/2025').toDateString()){
          this.lightboxItems.push(this.$hostname + 'time-tracking/preview/' + p)
        }
      })
      if (this.lightboxItems.length > 0) {
        this.index = 0
      } else {
        this.downloadDocument(item)
      }
    },

    putClient() {
      this.$axios
          .put(
              this.$hostname + "time-tracking/clients",
              {
                id: this.currentClient.id,
                name: this.currentClient.name,
                short_name: this.currentClient.short_name,
                ogrn: this.currentClient.ogrn,
                business_address: JSON.stringify(this.currentClient.business_address),
                phone: this.currentClient.phone,
                email: this.currentClient.email.toLowerCase().replace(" ", ""),
                site: this.currentClient.site,
                vat: this.currentClient.vat,
                branch: this.currentClient.branch,
                logo_path: this.currentClient.logo_path ?? "",
                read_timings: this.currentClient.read_timings,
              },
              {
                headers: {
                  Authorization:
                      "Token " +
                      (localStorage.getItem("auth_token") ||
                          sessionStorage.getItem("auth_token")),
                  "Content-Type": "multipart/form-data",
                },
              }
          ).then(() => {
        this.editing = false
        this.loadData();
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      })
    },
    clickInput() {
      document.getElementById("photo").click();
    },
    edit_profile() {
      if (this.photo != null)
        this.uploadFile(this.photo);
      else {
        this.putClient();
      }
    },
    uploadFile(file) {
      this.$axios({
        url: this.$hostname + "time-tracking/images/upload/clients",
        method: "POST",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          file: file,
        },
      })
          .then((response) => {
            this.currentClient.logo_path = response.data.data;
            if (this.editing) {
              this.putClient();
            }
          })
          .catch((error) => {
            this.alertMsg = "Ошибка загрузки файла";
            switch (error.response.status) {
              case 400:
                this.alertMsg = error.message;
                break;
              case 403:
                this.alertMsg = "Доступ запрещен";
                break;
              case 404:
                this.alertMsg = "Страница не найдена";
                break;
            }
            alert(this.alertMsg);
          });
    },

    contact_create_open(item = null) {
      this.contact_create_modal = true;

      if (item != null) {
        this.newContact = {
          id: item.id,
          name: item.name,
          lastname: item.lastname,
          position: item.position.id,
          phone: item.phone,
          email: item.email,
          client: item.client.id,
          photo_path: item.photo_path,
        };
      } else {
        this.newContact = {
          name: "",
          lastname: "",
          position: "",
          phone: "",
          email: "",
          client: this.currentClient.id,
          photo_path: "",
          active: true
        };
      }
    },
    confirm_contact_open(id) {
      this.confirm_contact_modal = true;
      this.contact_to_delete = id;
    },
    deleteContact() {
      this.$axios
          .delete(this.$hostname + "time-tracking/clients-employees", {
            data: {
              id: this.contact_to_delete,
            },
            headers: {
              Authorization:
                  "Token " +
                  (localStorage.getItem("auth_token") ||
                      sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            this.confirm_contact_modal = false;
            this.loadContacts()
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },

    addDetail() {
      if (this.newDetail.id) {
        this.putDetail()
        return
      }
      this.newDetail.options = JSON.stringify(this.newDetail.options)
      if (this.profile)
        this.newDetail.client = this.currentClient.id
      this.$axios({
        url: this.$hostname + "time-tracking/clients/details",
        method: "POST",
        headers: {
          Authorization: "Token " + (localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newDetail,
      }).then(() => {
        this.closeAddDetail()
        this.loadDetails()
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
        this.newDetail.options = JSON.parse(this.newDetail.options)
      })
    },
    putDetail() {
      this.newDetail.options = JSON.stringify(this.newDetail.options)
      if (this.profile)
        this.newDetail.client = this.currentClient.id
      this.$axios({
        url: this.$hostname + "time-tracking/clients/details",
        method: "PUT",
        headers: {
          Authorization: "Token " + (localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newDetail,
      }).then(() => {
        this.newDetail.options = JSON.parse(this.newDetail.options)
        this.closeAddDetail()
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    deleteDetail() {
      this.newDetail.options = JSON.stringify(this.newDetail.options)
      this.$axios({
        url: this.$hostname + "time-tracking/clients/details",
        method: "DELETE",
        headers: {
          Authorization: "Token " + (localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {id: this.detail_delete},
      }).then(() => {
        this.loadData()
        this.confirm_detail_modal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
        this.newDetail.options = JSON.parse(this.newDetail.options)
      })
    },
    editDetailOpen(item) {
      this.newDetail = item
      this.addDetailModal = true
      this.detail_action = "edit"
    },
    closeAddDetail() {
      this.addDetailModal = false
      this.newDetail = {
        options: {},
        client: this.id,
      }
    },
  },

  computed: {
    ...mapGetters(['permissions']),
  }
};
</script>
